// extracted by mini-css-extract-plugin
export default {"wrapper":"office_wrapper__gjXka","inside":"office_inside__jkYhq","title":"office_title__l2O+t","item":"office_item__BQjTz"};